import { render } from "./Base.vue?vue&type=template&id=4888728a"
import script from "./Base.vue?vue&type=script&setup=true&lang=js"
export * from "./Base.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/components/Base.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4888728a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4888728a', __exports__)) {
    api.reload('4888728a', __exports__)
  }
  
  module.hot.accept("./Base.vue?vue&type=template&id=4888728a", () => {
    api.rerender('4888728a', render)
  })

}


export default __exports__